import React, { FC, useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import {
    clearStatus,
    selectCurrentCandidatePipelineStatus,
    selectCurrentCandidatePipelineProfiles,
    getCurrentCandidatePipelineAsync
} from "../../features/client/currentCandidatePipelineSlice";

import styled from "styled-components";

import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Spinner from "react-bootstrap/Spinner";

import { CandidateProfileList } from "./candidate-profile-list";

import { top_prospects_profiles } from "../../api/topProspectProfileData";


type CurrentCandidatePipelinePageProps = {};

export const CurrentCandidatePipelinePage: FC<CurrentCandidatePipelinePageProps> = () => {

    // const queryParams = new URLSearchParams(window.location.search);

    const dispatch = useAppDispatch();

    const status = useAppSelector(selectCurrentCandidatePipelineStatus);
    const profiles = top_prospects_profiles;//useAppSelector(selectCurrentCandidatePipelineProfiles);

    useEffect(()=> {
        dispatch(getCurrentCandidatePipelineAsync());

    },[]) // empty array means it only run once

    const handleButtonClick = () => {
        const subject = "Top Prospects Custom Search";
        const bodyText = "Please tell us a little about your company and the role that you are looking to fill."
        const emailLink = `mailto:info@sourcecoders.io?subject=${subject}&body=${bodyText}`;
        window.location.href = emailLink;
    };

    return (
        <>
            <Container>
                <ContentSection className="w-100 m-auto">
                    <Title>Top Prospects Portal</Title>
                    <Description>
                        <div className="mb-3">Here is the current list of our top prospect candidates. If none of these satisfy your requirements, please click the button below for a customized search.</div>
                        <InterestedButton className="mb-3" onClick={handleButtonClick}>Custom Search</InterestedButton>
                    </Description>
                    {status == 'loading' && (
                        <div
                            style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            }}
                        >
                            <Spinner
                            as="span"
                            animation="border"
                            role="status"
                            aria-hidden="true"
                            style={{ marginBottom: '8px' }}
                            />
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    )}

                    <CandidateProfileList candidates={profiles} />
                </ContentSection>
            </Container>
        </>
    );
}

const ContentSection = styled.div`
    max-width: 700px;
    padding: 15px;
`;

const Title = styled.h1`
    font-size: 48px;
    font-weight: 700;
    line-height: 56px;
    letter-spacing: -0.5px;
    color: #1E1E1E;
    margin-bottom: 1rem;
`;

const Description = styled.p`
    font-size: 1rem;
    margin-bottom: 2rem;
`;

const InterestedButton = styled(Button)`
  background-color: #28a745;
  border-color: #28a745;
  min-width: 130px;
  &:hover {
    background-color: #218838;
    border-color: #1e7e34;
  }
`;
